<template>
  <svg xmlns="http://www.w3.org/2000/svg">
    <path
      d="m21 11h-14.17l3.585-3.585-1.415-1.415-6 6 6 6 1.415-1.415-3.585-3.585h14.17z"
    />
  </svg>
</template>
